/** Cancellable setTimeout scheduler for retry flows (e.g. offline sync). */
export function createCancellableRetryRunner() {
  const timers = new Set();

  return {
    schedule(callback, delayMs) {
      const timerId = setTimeout(() => {
        timers.delete(timerId);
        callback();
      }, delayMs);
      timers.add(timerId);
      return timerId;
    },
    cancelAll() {
      timers.forEach((timerId) => clearTimeout(timerId));
      timers.clear();
    }
  };
}

export const SYNC_RETRY_DELAY_MS = 5000;
export const SYNC_MAX_RETRIES = 3;
